import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';

const storeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

/**
 * @param {GlobalState} initialState
 * @param {*} rootReducer
 */
const createStoreFromStateAndReducer = (initialState, rootReducer) =>
  createStore(rootReducer, initialState, storeEnhancers(applyMiddleware(thunk)));

export default createStoreFromStateAndReducer;
